// Global logout utility to handle WorkOS logout from non-React contexts
// This allows the service layer to trigger logout when needed

/**
 * Triggers a global logout event that can be handled by React components
 * This is specifically designed for cases where WorkOS signOut needs to be called
 * from contexts that don't have access to the useAuth hook (like service.ts)
 */
export const triggerGlobalLogout = (): void => {
  // Create a custom event to signal that logout is needed
  const logoutEvent = new CustomEvent("workos-logout-required", {
    detail: {
      reason: "unauthorized",
      timestamp: Date.now(),
    },
  });

  // Dispatch the event to be handled by components with WorkOS access
  window.dispatchEvent(logoutEvent);

  console.log(
    "[GlobalLogout] Logout event triggered - WorkOS signOut will be handled by authenticated component",
  );
};
